import { planet } from "assets/icons/index";
import { useTranslation } from "react-i18next";

interface LangButtonProps {}

const LangButton = ({}: LangButtonProps) => {
  const { i18n } = useTranslation();

  const handleChangeLanguage = (language: any) => {
    i18n.changeLanguage(language);
    localStorage.setItem("i18nextLng", language);

    const direction = language === "ar" ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", direction);
    localStorage.setItem("dir", direction);

    window.location.reload();
  };

  return (
    <>
      {i18n.language === "en" && (
        <div
          onClick={() => handleChangeLanguage("ar")}
          className={`flex items-center gap-1 lg:gap-2 cursor-pointer hover:text-first_color font-Almarai`}
        >
          العربية
          <img src={planet} alt="logo" />
        </div>
      )}

      {i18n.language === "ar" && (
        <div
          onClick={() => handleChangeLanguage("en")}
          className="flex items-center gap-1 lg:gap-2 cursor-pointer hover:text-first_color"
        >
          English
          <img src={planet} alt="logo" />
        </div>
      )}
    </>
  );
};

export default LangButton;
